import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const SparePartListComponent = () => {
  const { listTypeId } = useParams(); 
  const navigate = useNavigate();

 
  const [sparePartsList, setSparePartsList] = useState([]);

  useEffect(() => {
    async function fetchSpareParts() {
      try {
        const response = await axios.get(`http://161.97.115.122:5000/spare-part-list/${listTypeId}`);
        setSparePartsList(response.data); 
      } catch (error) {
        console.error("Błąd podczas pobierania listy części zamiennych:", error);
      }
    }

    fetchSpareParts();
  }, [listTypeId]); 

  return (
<div className="app-container">
    <div className="sidebar">
     <img className="logo" src="https://agrofrankopol-sklep.pl/wp-content/uploads/2022/05/logo-1024x635.png" alt="Logo" />

  <div className="menu">
 
    <ul>
         <li><a href="http://161.97.115.122:3000/">Strona Główna</a></li>
        <li><a href="https://agrofrankopol-sklep.pl/">Sklep internetowy</a></li>
        <li><a href="https://agrofrankopol-sklep.pl/kontakt/">Kontakt</a></li>
    </ul>
</div>
    </div>
    <div className="content">
                    <button onClick={() => navigate(-1)} className="back-button">Wstecz</button>

    <div className="katalog">
      <h1>Lista Części Zamiennych</h1>
      <ul>
        {sparePartsList.map(sparePart => (
       
           <li key={sparePart._id} className="type-item">
          <div className="type-image">
          </div>
          <div className="type-info">
            <Link to={`/parts/${sparePart._id}`} className="type-link">
              {sparePart.nazwa}
            </Link>
          </div>
        </li>
      ))}
        
        
      </ul>
    </div>
    </div>
    </div>
  );
}

export default SparePartListComponent; // Eksportowanie komponentu
